import React from 'react';
import { getPaymentStatusLabel, getDocumentStatusLabel } from '../utils/statusMap';
import { PaymentStatus, DocumentStatus } from '../types/statuses';

interface StatusBadgeProps {
  status: PaymentStatus | DocumentStatus;
  type: 'payment' | 'document';
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, type, className = '' }) => {
  const label = type === 'payment'
    ? getPaymentStatusLabel(status as PaymentStatus)
    : getDocumentStatusLabel(status as DocumentStatus);

  const resolveVariant = (): 'settled' | 'pending' | 'active' | 'rejected' | 'neutral' => {
    const normalizedStatus = String(status).toLowerCase();

    if (
      normalizedStatus.includes('approved') ||
      normalizedStatus.includes('completed') ||
      normalizedStatus.includes('success')
    ) {
      return 'settled';
    }

    if (
      normalizedStatus.includes('pending') ||
      normalizedStatus.includes('wait') ||
      normalizedStatus.includes('initiated')
    ) {
      return 'pending';
    }

    if (
      normalizedStatus.includes('processing') ||
      normalizedStatus.includes('trackable') ||
      normalizedStatus.includes('active')
    ) {
      return 'active';
    }

    if (
      normalizedStatus.includes('reject') ||
      normalizedStatus.includes('fail') ||
      normalizedStatus.includes('cancel')
    ) {
      return 'rejected';
    }

    return 'neutral';
  };

  return (
    <span className={`status-badge status-badge--${resolveVariant()} ${className}`}>
      {label}
    </span>
  );
};

export default StatusBadge;
